import { localeConfig } from '@/legacy-src/constants/locale.config'
import { LOCALE, type Locale } from '@/legacy-src/constants/locale.constants'

export const languages = {}

for (const locale in localeConfig) {
  languages[localeConfig[locale].displayName] = '.' + localeConfig[locale].domain
}

export const getLocaleDomain = (locale: Locale) => localeConfig[locale]?.domain
export const getLocaleDisplayName = (locale: Locale) => localeConfig[locale]?.displayName
export const getFullDomain = (locale: Locale) => {
  if (locale === LOCALE) {
    const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'

    if (isProduction) {
      const productionUrl = process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL
      if (productionUrl) {
        return `https://${productionUrl}`
      }
    } else {
      const vercelUrl = process.env.NEXT_PUBLIC_VERCEL_URL
      if (vercelUrl) {
        return `https://${vercelUrl}`
      }
    }
  }

  return `https://hedepy.${getLocaleDomain(locale)}`
}
